exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  background: #EEE;\n}\n\npre {\n  font-size: 1em;\n  background: white;\n}\n", ""]);

